import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

export function observableTakeOne<T>(observable: Observable<T>, takeOne = true): Observable<T> {
  if (takeOne) {
    return observable.pipe(take(1));
  }
  return observable;
}
